export default __webpack_public_path__ + "opex.png";